var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlurryGradientHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur1",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 161,
    result: "effect1_foregroundBlur"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#C62368"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blur1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 138,
    fill: "#FCAF3C",
    r: 357
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524,
    cy: 236,
    fill: "#C62368",
    r: 357
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 779,
    cy: 128,
    fill: "#FCAF3C",
    r: 357
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 315,
    fill: "#FCAF3C",
    r: 357
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842,
    cy: 463,
    fill: "#C62368",
    r: 357
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 381,
    fill: "#FCAF3C",
    r: 357
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurryGradientHaikei);
export default __webpack_public_path__ + "static/media/blurry-gradient-haikei.ed2de154788c23bfad7f75d891618a0b.svg";
export { ForwardRef as ReactComponent };